var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackdrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#95C142",
    d: "M98.341,9.951c-2.325,11.315-4.642,22.633-6.971,33.948         c-2.124,10.319-4.264,20.636-6.39,30.954c-0.278,1.35,0.122,2.158,1.093,2.31c0.937,0.147,1.479-0.38,1.709-1.761         c1.004-6.006,1.993-12.013,2.984-18.02c1.927-11.667,3.852-23.333,5.778-35c0.73-4.427,1.465-8.853,2.198-13.279         c-0.054-0.013-0.107-0.025-0.16-0.039C98.501,9.36,98.402,9.652,98.341,9.951z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#B03F95",
    d: "M37.932,42.655c-0.325,0.215-0.677,0.411-0.948,0.684         c-0.534,0.537-0.598,1.19-0.185,1.815c0.415,0.627,1.027,0.834,1.736,0.507c0.315-0.146,0.602-0.361,0.886-0.565         c15.213-10.899,30.433-21.789,45.628-32.711c2.617-1.881,5.333-3.629,7.809-5.704c-0.423-0.049-0.689,0.272-0.99,0.47         C73.885,18.979,55.908,30.816,37.932,42.655z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#B03F95",
    d: "M92.882,6.661c-0.008,0.007-0.017,0.013-0.024,0.019         c0.016,0.002,0.026-0.004,0.042-0.001L92.882,6.661z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#E23B92",
    d: "M95.973,10.921C91.193,21.611,86.414,32.3,81.634,42.99         c-1.784,3.991-3.577,7.977-5.353,11.972c-0.485,1.093-0.15,2.03,0.809,2.269c1.085,0.271,1.554-0.424,1.891-1.296         c5.654-14.636,11.311-29.271,16.964-43.907c0.138-0.357,0.357-0.708,0.209-1.122C96.094,10.91,96.033,10.916,95.973,10.921z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#612C77",
    d: "M57.542,18.046c-3.971,1.512-7.941,3.024-11.907,4.551         c-1.197,0.461-1.622,1.407-1.026,2.243c0.642,0.9,1.455,0.686,2.298,0.313C61.382,18.74,75.86,12.333,90.337,5.925         c-0.148-0.065-0.298-0.131-0.446-0.197C79.108,9.834,68.325,13.939,57.542,18.046z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F3A32B",
    d: "M54.469,0.327c-1.002-0.035-1.711,0.301-1.83,1.359         c-0.102,0.912,0.632,1.493,1.829,1.464c2.265-0.055,4.527-0.146,6.791-0.223c9.681-0.329,19.36-0.658,29.041-0.988         c0-0.13,0-0.261,0-0.392c-1.054-0.04-2.107-0.083-3.161-0.118C76.248,1.063,65.358,0.701,54.469,0.327z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#612C77",
    d: "M93.544,7.892C88.007,13.01,82.473,18.13,76.938,23.25         c-2.064,1.91-4.132,3.818-6.191,5.734c-0.711,0.662-0.833,1.407-0.158,2.16c0.564,0.63,1.45,0.556,2.167-0.134         c0.141-0.135,0.268-0.285,0.4-0.428c6.448-6.968,12.896-13.934,19.343-20.904c0.706-0.764,1.395-1.544,2.091-2.317         c-0.062-0.069-0.122-0.139-0.184-0.208C94.118,7.398,93.821,7.635,93.544,7.892z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ED792D",
    d: "M77.142,37.884c-3.252,4.678-6.496,9.361-9.74,14.044         c-1.467,2.117-2.939,4.229-4.392,6.356c-0.668,0.978-0.565,1.861,0.221,2.338c0.798,0.484,1.57,0.188,2.197-0.848         c0.081-0.135,0.155-0.271,0.231-0.408c3.64-6.502,7.28-13.003,10.919-19.505c0.468-0.835,0.927-1.675,1.523-2.756         C77.423,37.319,77.313,37.638,77.142,37.884z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#95C142",
    d: "M34.024,15.547c-1.33,0.241-1.894,0.921-1.633,1.904         c0.232,0.875,0.993,1.184,2.212,0.84c8.26-2.326,16.518-4.661,24.775-6.993c-0.084-0.095-0.169-0.189-0.252-0.284         C50.76,12.523,42.392,14.031,34.024,15.547z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#E23B92",
    d: "M93.23,0.371c-0.13-0.05-0.257-0.116-0.392-0.148         c-0.31-0.074-0.62-0.148-0.93-0.223h-3.723c1.658,0.213,3.316,0.428,4.974,0.641C93.185,0.551,93.208,0.461,93.23,0.371z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#612C77",
    d: "M99.864,9.613c0,0.422,0.008,0.792-0.002,1.162         c-0.196,7.261-0.395,14.521-0.592,21.782c-0.079,2.928-0.153,5.855-0.233,8.783c-0.02,0.701,0.006,1.434,0.923,1.46         c0.016,0,0.025-0.003,0.04-0.003V9.728C99.96,9.688,99.929,9.648,99.864,9.613z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#95C142",
    d: "M95.988,7.704c-3.772,5.224-7.539,10.452-11.3,15.685         c-0.757,1.054-0.729,1.935,0.044,2.464c0.843,0.577,1.659,0.258,2.324-0.953c3.101-5.647,6.193-11.298,9.281-16.951         c0.12-0.22,0.382-0.42,0.224-0.739C96.211,7.196,96.131,7.507,95.988,7.704z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ED792D",
    d: "M48.238,4.892c1.754-0.021,3.111-1.366,3.131-3.102         c0.008-0.669-0.181-1.283-0.511-1.79h-5.256c-0.331,0.489-0.531,1.071-0.542,1.697C45.031,3.441,46.494,4.913,48.238,4.892z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#20ADB3",
    d: "M73.808,6.696c-0.682,0.123-1.263,0.396-1.09,1.206         c0.188,0.878,0.852,0.883,1.563,0.644c0.11-0.037,0.226-0.062,0.339-0.092c6.019-1.61,12.036-3.221,18.055-4.832         c0.029-0.154,0.059-0.308,0.087-0.461c-4.593,0.863-9.186,1.728-13.779,2.588C77.258,6.071,75.533,6.384,73.808,6.696z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F3A32B",
    d: "M97.351,53.502c-0.018,1.496,1.151,2.68,2.639,2.672         c0.004,0,0.007-0.001,0.011-0.001v-5.351C98.556,50.812,97.369,52.01,97.351,53.502z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#95C142",
    d: "M81.979,27.341c-1.441-0.011-2.697,1.259-2.665,2.696         c0.033,1.46,1.304,2.667,2.749,2.612c1.386-0.053,2.582-1.316,2.557-2.699C84.595,28.563,83.368,27.352,81.979,27.341z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#20ADB3",
    d: "M63.349,36.254c-1.125,0.026-2.085,1.025-2.057,2.139         c0.029,1.134,1,2.059,2.144,2.042c1.148-0.017,2.043-0.958,2.023-2.128C65.439,37.162,64.479,36.228,63.349,36.254z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F3A32B",
    d: "M100,72.135v-0.598c-0.126-0.109-0.253-0.225-0.381-0.362         C99.81,71.518,99.929,71.834,100,72.135z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F3A32B",
    d: "M98.555,74.666c0.597-0.146,1.063-0.138,1.445-0.027v-1.474         C99.827,73.75,99.346,74.242,98.555,74.666z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#612C77",
    d: "M28.849,1.878c1.839,0.143,2.471,1.088,2.155,2.871         c0.784-1.657,1.902-1.933,3.458-1.095c-1.309-1.226-1.384-2.36,0.132-3.567C33.074,0.352,32.589,0.422,31.987,0h-0.917         C31.02,1.096,30.161,1.6,28.849,1.878z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#95C142",
    d: "M71.276,34.605c-0.116,1.096-0.872,0.928-1.662,1.034         c0.991,0.449,0.605,1.081,0.379,1.861c0.811-0.906,1.291-0.137,2.058,0.356c-0.457-0.984-0.241-1.51,0.581-1.849         C71.709,35.993,71.457,35.44,71.276,34.605z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#B03F95",
    d: "M90.337,5.925c0.913-0.391,1.827-0.781,2.74-1.171         c-1.152,0.087-2.188,0.475-3.187,0.975C90.039,5.794,90.188,5.86,90.337,5.925z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#D6D7DC",
    d: "M92.449,1.515c0,0.152,0,0.304,0,0.457         c0.959-0.026,1.937,0.134,2.87-0.132c-0.002-0.108-0.005-0.216-0.007-0.324C94.358,1.515,93.403,1.515,92.449,1.515z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#D6D7DC",
    d: "M97.707,7.305c-0.697,0.794-1.024,1.731-1.164,2.743         C97.204,9.245,97.53,8.304,97.707,7.305z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F0B75D",
    d: "M59.379,11.298c0.846-0.185,1.706-0.326,2.445-0.878         c-0.898,0.198-1.798,0.396-2.697,0.594C59.21,11.109,59.295,11.203,59.379,11.298z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#D6D7DC",
    d: "M92.674,3.622c0.691-0.148,1.455-0.105,2.12-0.761         c-0.797-0.003-1.433,0.024-2.033,0.299C92.732,3.314,92.703,3.468,92.674,3.622z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F0B75D",
    d: "M90.3,1.939c0.717,0.011,1.433,0.022,2.149,0.033         c0-0.152,0-0.305,0-0.457c-0.716,0.011-1.433,0.021-2.149,0.032C90.3,1.678,90.3,1.809,90.3,1.939z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#D6D7DC",
    d: "M98.063,6.158c-0.105,0.083-0.179,0.231-0.218,0.365         c-0.016,0.057,0.113,0.223,0.141,0.215c0.207-0.059,0.264-0.235,0.277-0.432C98.229,6.207,98.208,6.045,98.063,6.158z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#B03F95",
    d: "M92.899,6.679c0.002-0.01,0.008-0.015,0.01-0.024         c-0.01,0.001-0.018,0.006-0.027,0.007L92.899,6.679z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#B03F95",
    d: "M92.909,6.654c0.287-0.046,0.493-0.221,0.677-0.43         C93.264,6.215,92.993,6.286,92.909,6.654z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#B03F95",
    d: "M93.602,6.208c-0.005,0.005-0.011,0.011-0.016,0.016         c0.013,0,0.023-0.001,0.035-0.001L93.602,6.208z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#D6D7DC",
    d: "M95.24,2.828c-0.002,0.014,0.121,0.054,0.215,0.095         c0.08-0.032,0.18-0.071,0.278-0.11c-0.054-0.04-0.106-0.11-0.161-0.112C95.448,2.696,95.282,2.628,95.24,2.828z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#D6D7DC",
    d: "M95.973,10.921c0.061-0.005,0.121-0.011,0.181-0.016         c0.015-0.127,0.028-0.255,0.043-0.382C95.925,10.545,95.988,10.755,95.973,10.921z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#B03F95",
    d: "M93.621,6.224c0.001-0.011,0.002-0.022,0.003-0.033         c-0.008,0.005-0.015,0.011-0.022,0.017C93.602,6.208,93.621,6.224,93.621,6.224z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#B03F95",
    d: "M93.638,6.034c-0.005,0.052-0.01,0.105-0.014,0.157         c0.043-0.033,0.086-0.066,0.129-0.099C93.714,6.073,93.676,6.053,93.638,6.034z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackdrop);
export default __webpack_public_path__ + "static/media/backdrop.c4a1e635.svg";
export { ForwardRef as ReactComponent };